import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0183a09b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0183a09b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0183a09b')) {
      api.createRecord('0183a09b', component.options)
    } else {
      api.reload('0183a09b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0183a09b&scoped=true", function () {
      api.rerender('0183a09b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/wxAccount/reply/keyword/index.vue"
export default component.exports